import { Controller } from "@hotwired/stimulus"
import { requestNotificationPermission } from "../firebase-init"

// Connects to data-controller="notification-permission"
export default class extends Controller {
  static targets = ["button", "status"]

  declare buttonTarget: HTMLButtonElement
  declare statusTarget: HTMLDivElement
  declare hasStatusTarget: boolean

  async request(): Promise<void> {
    this.buttonTarget.classList.add("loading")
    
    try {
      const token = await requestNotificationPermission()
      
      if (token) {
        // Send the token to our Rails backend
        const response = await fetch("/app_users/device_push_notification_token", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ""
          },
          body: JSON.stringify({ push_notification_token: token })
        })

        if (response.ok) {
          this.buttonTarget.classList.add("btn-success")
          this.buttonTarget.classList.remove("btn-primary")
          this.buttonTarget.textContent = "Notifications Enabled"
          this.buttonTarget.disabled = true

          if (this.hasStatusTarget) {
            this.statusTarget.textContent = "Push notifications are now enabled for this device."
            this.statusTarget.classList.remove("hidden")
          }
        } else {
          throw new Error("Failed to save notification token")
        }
      } else {
        this.buttonTarget.classList.add("btn-error")
        this.buttonTarget.textContent = "Permission Denied"
        
        if (this.hasStatusTarget) {
          this.statusTarget.textContent = "You have denied permission for push notifications."
          this.statusTarget.classList.remove("hidden")
        }
      }
    } catch (error) {
      console.error("Error requesting notification permission:", error)
      this.buttonTarget.classList.add("btn-error")
      this.buttonTarget.textContent = "Error"
      
      if (this.hasStatusTarget) {
        this.statusTarget.textContent = "An error occurred while enabling push notifications."
        this.statusTarget.classList.remove("hidden")
      }
    } finally {
      this.buttonTarget.classList.remove("loading")
    }
  }
} 